export const SIZE_OPTIONS_TYPE = {
    KEEP_ORIGINAL: 'KEEP_ORIGINAL',
    SCALE_DOWN_BY_PERCENTAGE: 'SCALE_DOWN_BY_PERCENTAGE',
    SCALE_DOWN_BY_DIMENSIONS: 'SCALE_DOWN_BY_DIMENSIONS',
}
